import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { saveAs } from 'file-saver';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { DetParticipanteService } from 'src/app/service/det-participante.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { MaeProcesoService } from 'src/app/service/mae-proceso.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';

import { MaeConstanciaE,MaeConstanciaM } from 'src/app/model/mae-constancia-bean';
import { DetParticipanteE,DetParticipanteM,MovFirmaParticipanteM } from 'src/app/model/det-participante-bean';
import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { MatDialog } from "@angular/material/dialog";

import { DmlParticipanteComponent } from 'src/app/pagina-admin/dashboard/gestion-participante/dml-participante/dml-participante.component';
import { DmlParticipanteAVComponent } from 'src/app/pagina-admin/dashboard/gestion-participante/dml-participante-av/dml-participante-av.component';
import { DmlFirmaComponent } from 'src/app/pagina-admin/dashboard/gestion-participante-firma/dml-firma/dml-firma.component';
import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';

@Component({
  selector: 'app-gestion-participante-firma',
  templateUrl: './gestion-participante-firma.component.html',
  styleUrls: ['./gestion-participante-firma.component.scss']
})
export class GestionParticipanteFirmaComponent implements OnInit {
  constructor(
  private route: ActivatedRoute,
  private modalService: MDBModalService,
  private maeConstanciaService:MaeConstanciaService,
  private utilitarioService:UtilitarioService,
  private detParticipanteService:DetParticipanteService,
  private maeTablaService:MaeTablaService,
  private maeProcesoService:MaeProcesoService,
  private globalVariablesService: GlobalVariablesService,
  private detArchivoService:DetArchivoService,
  private dialogo: MatDialog,
  private router : Router,
  ) { localStorage.setItem('iterador', '0');}

   // datos generales
   id_constancia:String;
   c_tipo:String;
   a_tipo:String;
   x_titulo:String;

   c_iduser:String;

   tipo_participante:String;
   nombre_constancia:String;

   //filtro
  txt_nombre:String = "";
  cboEstado:String = "0";

  //documento
  maeConstanciaE = new MaeConstanciaE();
  listParticipantes = new Array<MovFirmaParticipanteM>();
  listParticipantesCompleto = new Array<MovFirmaParticipanteM>();
  listEstado= new Array<Mae_tabla_E>();


  //modal
  //modalRefFirmaDml: MDBModalRef;

  page = 1;
  pageSize = 10;

  headElements = ['Nro','Nombre','Estado','Archivos','Firmar','Observado'];

  ngOnInit(): void {

    this.c_iduser = this.globalVariablesService.getC_usuario_firma();

    //recuperar parametro
    this.route.params.subscribe((params: Params) => {
      //console.log(params);
      this.a_tipo = params['tipo'];
      this.id_constancia = params['id'];

    });
    this.cargarDatoInicial();
  }
  cargarDatoInicial(){

    if(this.a_tipo==='a')
    {
      this.c_tipo = '19';
      this.tipo_participante = "Alumnos";
    }
    else
    {
      this.c_tipo = '20';
      this.tipo_participante = "Profesores";
    }

    const cargarEstado = this.maeTablaService.getList("ESTADO_FIRMA").toPromise()
    .then(result => {
      this.listEstado = result;
    });

    this.utilitarioService.loading = true;
    const cargarConstancia = this.maeConstanciaService.get(this.id_constancia.toString()).toPromise()
    .then(result => {
      this.maeConstanciaE = result[0];
      this.x_titulo = this.maeConstanciaE.x_titulo.toLowerCase();
    });

    Promise.all([cargarConstancia,cargarEstado])
      .then(response => {
        this.nombre_constancia = this.maeConstanciaE.x_curso;
        this.onBuscar();
        this.utilitarioService.loading = false;
      });
  }
  onBuscar(){

    this.utilitarioService.loading = true;

    var nombre = "*";
    if(this.txt_nombre.toString().length>0)    nombre = this.txt_nombre.toString();

    console.log("nombres->"+nombre+",estado->"+this.cboEstado)

    this.detParticipanteService.getfindsign(this.id_constancia.toString(),nombre,this.c_iduser.toString()).subscribe(data=>{
      this.listParticipantes = data;
      this.listParticipantesCompleto = data;
      this.utilitarioService.loading = false;
    });

  }
  onChangeEstado()
  {
    if(this.cboEstado==="0")
      this.listParticipantes = this.listParticipantesCompleto;
    else
      this.listParticipantes = this.listParticipantesCompleto.filter(x=>x.c_estado===this.cboEstado );

  }
  onDescargarArchivo(parti:MovFirmaParticipanteM){
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(parti.x_uid.toString()).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,"documento_"+parti.c_participante+".pdf");
    });
  }
  onFirmarTodos()
  {
    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: '¿Desea realizar la firma en bloque?, se juntara un maximo de 25 certificados de los participantes.'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {

      if (confirmado) {

        this.utilitarioService.loading=true;
        this.maeProcesoService.bajarparajuntarenZip(this.id_constancia.toString(), this.c_iduser.toString()).subscribe( (response_dml_bean : Response_dml_bean) => {

          this.utilitarioService.loading=false;
          if (response_dml_bean.codigoRespuestaServicio=="1"){
            console.log(response_dml_bean.mensaje);
            // se redirecciona a firmar
            this.router.navigate(['dashboard/firmar/m'+this.a_tipo+'/'+this.id_constancia]);
          }
          else
            this.utilitarioService.toastrError(response_dml_bean.mensaje);
          console.log(response_dml_bean);
        },
        error=>{
          this.utilitarioService.toastrError("Hubo un error al realizar la observacion." + error.error.messages.toString());
          this.utilitarioService.loading=false;
        });
      } else {
        return;
      }
    });
  }
  onObservar(id_participante:string,idfirma:string)
  {
      console.log(this.id_constancia.toString());
    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: '¿Desea observar el participante seleccionado?'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {

      if (confirmado) {
        this.utilitarioService.loading=true;
        this.maeProcesoService.observar(id_participante,idfirma).subscribe( (response_dml_bean : Response_dml_bean) => {

          this.utilitarioService.loading=false;
          if (response_dml_bean.codigoRespuestaServicio=="1"){
            this.utilitarioService.toastrInfo(response_dml_bean.mensaje);
            this.onBuscar();
          }
          else
            this.utilitarioService.toastrError(response_dml_bean.mensaje);
          console.log(response_dml_bean);
        },
        error=>{
          this.utilitarioService.toastrError("Hubo un error al realizar la observacion." + error.error.messages.toString());
          this.utilitarioService.loading=false;
        });
      } else {
        return;
      }
    });
  }
  onObservarTodos()
  {
      console.log(this.id_constancia.toString());
    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: '¿Desea observar a todos los participantes que tengan el estado LISTO PARA FIRMAR?'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {

      if (confirmado) {
        this.utilitarioService.loading=true;
        this.maeProcesoService.observartodos(this.id_constancia.toString(),this.c_iduser.toString()).subscribe( (response_dml_bean : Response_dml_bean) => {

          this.utilitarioService.loading=false;
          if (response_dml_bean.codigoRespuestaServicio=="1"){
            this.utilitarioService.toastrInfo(response_dml_bean.mensaje);
            this.onBuscar();
          }
          else
            this.utilitarioService.toastrError(response_dml_bean.mensaje);
          console.log(response_dml_bean);
        },
        error=>{
          this.utilitarioService.toastrError("Hubo un error al realizar la observacion." + error.error.messages.toString());
          this.utilitarioService.loading=false;
        });
      } else {
        return;
      }
    });
  }
}
